import styled from 'styled-components';

const Wrapper = styled.div`
  color: var(--white);
  background-color: var(--primary-500);
  padding: 2rem 0;
  text-align: center;
  font-size: 0.85rem;

  p {
    margin-top: 0;
  }

  .action-container {
    display: flex;
    justify-content: center;
    align-items: center;

    a {
      color: var(--white);
      margin-right: 2rem;
      letter-spacing: var(--letterSpacing);
    }
    button {
      color: var(--white);
      border-color: var(--white);
    }
  }

  @media screen and (min-width: 768px) {
    font-size: 1rem;
  }
`;

export default Wrapper;
